import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import AutoTips from '@/components/AutoTips';

export default {
  components: {
    AutoTips: AutoTips
  },

  props: {
    groupList: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      currentId: '',
      listStyle: {}
    };
  },


  computed: {
    innerGroupList: function innerGroupList() {
      return this.groupList.map(function (item) {
        return _extends({}, item, {
          dco_preview_url: '' + item.preview_url + (item.preview_url.indexOf('?') !== -1 ? '&' : '?') + 'dco_gid=' + item.gid + '&preview=true' || ''
        });
      });
    }
  },

  methods: {
    handleClick: function handleClick(_ref) {
      var group = _ref.group;

      this.currentId = group.gid;
      this.$emit('changePreview', { group: group });
    },
    fillListHeight: function fillListHeight() {
      if (document.querySelector('.divce-wrap')) {
        this.listStyle = {
          // hack代码，因为外层的zoom: 0.75
          height: document.querySelector('.divce-wrap').offsetHeight * 0.75 - 44 + 'px'
        };
      }
    },
    triggerClick: function triggerClick() {
      var _this = this;

      var group = this.innerGroupList.find(function (item) {
        return item.gid === _this.currentId;
      });
      this.$emit('changePreview', { group: group });
    }
  },

  mounted: function mounted() {
    this.currentId = this.innerGroupList[0].gid;
    this.$emit('changePreview', { group: this.innerGroupList[0] });
    this.throttler = _.throttle(this.fillListHeight, 100);
    this.throttler();
    window.addEventListener('resize', this.throttler, false);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.throttler, false);
  }
};